const truncate = function (str) {
  let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 80;
  const strContent = str || '';
  if (strContent.length < length) {
    return strContent;
  }
  return `${strContent.slice(0, length)}...`;
};
export default truncate;